import React, { useState } from "react";
import CollapsableCard from "../../../commons/card/CollapsableCard";
import Header from "../../../commons/card/Header";
import Body from "../../../commons/card/Body";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { FormNumericTextBox } from "../../../commons/forms/form";
import { LabelInfo } from "../../../commons/forms/LabelInfo";
import ProduitsAssignesModal from "../../gant/components/modals/ProduitsAssignesModal";
import { useLazyGetInventaireQuery } from "../../../redux/api/cache";
import "./imageshd.css";
import LoaderContainer from "../../../commons/container/LoaderContainer";
import CustomModal from "../../../commons/modal/CustomModal";

export default function ImagesHD() {
  const [showProduitsAssignesModal, setShowProduitsAssignesModal] =
    useState(false);
  const [
    getInventaire,
    { isFetching: isInventaireFetching, isLoading: isInventaireLoading },
  ] = useLazyGetInventaireQuery();
  const [data, setData] = useState(undefined);
  const [showFullscreenImage, setShowFullscreenImage] = useState("");
  const update = async (dataItem) => {
    let result = await getInventaire({
      query: `methode=imagehd&mode=entete&ptr=${dataItem.prod_num}`,
    }).unwrap();
    setData(result.data);
  };

  return (
    <>
      <CollapsableCard canCollapse={false} style={{ backgroundColor: "white" }}>
        <div style={{ margin: "12px 0px" }}>
          <Header title={"Interrogation des images HD"}></Header>
        </div>
        <Body style={{ display: "flex", gap: "100px", padding: "1vh 1vw" }}>
          <div style={{ flexShrink: 0 }}>
            <Form
              onSubmit={update}
              render={() => (
                <div
                  style={{ border: "1px ridge #d0d0d0", borderRadius: "5px" }}
                >
                  <FormElement style={{ padding: "1vh 1vw" }}>
                    <Field
                      id={"prod_num"}
                      label={"Numéro de produit"}
                      name={"prod_num"}
                      min={0}
                      max={9999999}
                      component={FormNumericTextBox}
                    />
                    <Button
                      className="blueButton"
                      type={"submit"}
                      icon="search"
                      style={{ marginTop: "10px" }}
                    >
                      Rechercher
                    </Button>
                  </FormElement>
                </div>
              )}
            />
          </div>
          <div style={{ display: "flex", flexGrow: 1 }}>
            <LabelInfo
              label="Fournisseur"
              value={data?.entete?.[0]?.four_nom}
              col={4}
            />
            <LabelInfo
              label="Modèle"
              value={data?.entete?.[0]?.mod_descr}
              col={4}
            />
            <LabelInfo
              label="Fini"
              value={data?.entete?.[0]?.fini_cd}
              col={4}
            />
          </div>
          <Button
            iconClass="k-icon k-font-icon k-i-page-properties k-icon-xxxl"
            disabled={!data?.entete?.[0]?.prod_num}
            style={{ width: "75px", height: "75px" }}
            onClick={() => setShowProduitsAssignesModal(true)}
          ></Button>
        </Body>
      </CollapsableCard>
      <CollapsableCard canCollapse={false}>
        {isInventaireFetching || isInventaireLoading ? (
          <LoaderContainer />
        ) : (
          <Body>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              {data?.entete?.[0]?.doc
                ?.filter(
                  (d) =>
                    d.typeDoc === "Photo" && d.chemin.includes("cdn.tanguay.ca")
                )
                ?.map((item) => {
                  return (
                    <img
                      key={item.nom}
                      src={`${item.chemin}${item.nom}`}
                      alt={`Photo inexistante`}
                      style={{ width: 420, height: 300, cursor: "zoom-in" }}
                      onClick={() => {
                        setShowFullscreenImage(`${item.chemin}${item.nom}`);
                      }}
                      draggable={false}
                    />
                  );
                })}
            </div>
          </Body>
        )}
      </CollapsableCard>
      {showFullscreenImage && (
        <CustomModal
          closeIcon={true}
          width="100vh"
          height="90vh"
          title="Image du produit"
          onClose={() => setShowFullscreenImage("")}
          body={
            <img
              style={{ width: "100%", height: "100%" }}
              src={showFullscreenImage}
            />
          }
        />
      )}
      {showProduitsAssignesModal && (
        <ProduitsAssignesModal
          closeIcon={true}
          global={true}
          selectedRow={{ prod_num: data?.entete?.[0]?.prod_num }}
          toggle={() => setShowProduitsAssignesModal(false)}
        />
      )}
    </>
  );
}
